import { BaseFieldModel, IBaseFieldModel } from '../base/blueprint-field-base.model';

export interface IFieldDateModel extends IBaseFieldModel {
  isRequired: boolean;
  isReadOnly: boolean;
  value: Date | null;
}

export class FieldDateModel extends BaseFieldModel implements IFieldDateModel {
  constructor(
    public isRequired: boolean,
    public isReadOnly: boolean,
    public value: Date | null,
  ) {
    super(isRequired, isReadOnly);
  }
}
